import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@jti/ui/components/Button";
import { useAddProduct } from "../../hooks/useAddProduct";
export const QuickAddToCartCtaButton = ({ label, sku, theme, bundle = [], color = "primary", ...restProps }) => {
    const { isRunning, addProductToCart } = useAddProduct(sku, bundle, false);
    return (_jsx(Button, { ...restProps, onClick: () => addProductToCart(1), variant: "cta", color: color, theme: theme, isPending: isRunning, nativeBehaviour: true, children: label }));
};
//# sourceMappingURL=QuickAddToCartCtaButton.js.map